<button class="btn-controlbar btn-overlay btn-compact {{attributes.classes}}" id="{{attributes.cid}}-{{id}}"{{#unless text}} aria-label="{{attributes.ariaLabel}}"{{/unless}}{{#if attributes.actionTarget}} data-action-target="{{attributes.actionTarget}}"{{/if}} data-keep-aria-label-on-click="true">
  {{#if attributes.iconBefore}}
    {{>icon uuid=attributes.cid icon=attributes.iconBefore}}
  {{/if}}
  {{#each attributes.icons}}
    {{>icon uuid=(concat ../cid '-' @index) icon=icon classes=classes}}
  {{/each}}
  {{#if attributes.text}}{{attributes.text}}{{/if}}
  {{#if attributes.iconAfter}}
    {{>icon uuid=attributes.cid icon=attributes.iconAfter}}
  {{/if}}
</button>
<div aria-hidden="true" data-action-target="popover-{{id}}" class="btn-controlbar__popover-{{attributes.cid}}-{{id}}"></div>